import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import moment from 'moment';
import { formatTimeOption } from '../../helpers';
import { OVERTIME_SLOTS } from '../../constants';

const DeleteOvertimeSlot = ({ slotDetail, handleDeleteSlot }) => {
  const [show, setShow] = useState(false);
  const isSlotUsed = Number(slotDetail?.slotUsed || 0) > 0;

  const deleteButton = (
    <Button
      variant="white"
      className="btn btn-sm btn-white"
      disabled={isSlotUsed}
      onClick={() => setShow(true)}
    >
      <i className="mdi mdi-trash-can-outline" /> Delete
    </Button>
  );

  return (
    <>
      {isSlotUsed ? (
        // Disabled buttons don't fire mouse events, so the tooltip needs a wrapper
        <Tippy content={OVERTIME_SLOTS.SLOT_IN_USE} theme="light">
          <span className="d-inline-block">{deleteButton}</span>
        </Tippy>
      ) : (
        deleteButton
      )}

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header>
          <Modal.Title className="m-0">Delete Overtime Slot?</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            You are about to delete the overtime slot on{' '}
            <b>{moment(slotDetail?.otStartTz).format('MMMM D, YYYY')}</b> (
            {formatTimeOption(slotDetail?.otStart)?.label ||
              slotDetail?.otStart}{' '}
            - {formatTimeOption(slotDetail?.otEnd)?.label || slotDetail?.otEnd}
            ).
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="link" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShow(false);
              handleDeleteSlot(slotDetail._id);
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

DeleteOvertimeSlot.propTypes = {
  slotDetail: PropTypes.shape({
    _id: PropTypes.string,
    slotUsed: PropTypes.number,
    otStartTz: PropTypes.string,
    otStart: PropTypes.string,
    otEnd: PropTypes.string,
  }),
  handleDeleteSlot: PropTypes.func,
};

export default DeleteOvertimeSlot;
